import React from 'react';
import classNames from "classnames";


import './ProgressBarHorizontal.css';


export interface ProgressBarHorizontalProps {
    progress: number;
    className?: string;
    type?: 'info' | 'ai' | 'correct' | 'wrong' | 'accent';
    maxWidth?: number;
    height?: number;
}

export const ProgressBarHorizontal = (
    {
        progress,
        className,
        type,
        maxWidth,
        height,
    }: ProgressBarHorizontalProps
) => {
    return (
       <div className={classNames({
           "ProgressBarHorizontal": true,
           [className!]: className,
       })}
            style={{maxWidth: maxWidth, height: height}}>
           <div className={classNames({
               "ProgressBarHorizontal__bar": true,
               "ProgressBarHorizontal__bar--ai": type === 'ai',
               "ProgressBarHorizontal__bar--info": type === 'info',
               "ProgressBarHorizontal__bar--correct" : type === 'correct',
               "ProgressBarHorizontal__bar--wrong" : type === 'wrong',
               "ProgressBarHorizontal__bar--accent" : type === 'accent'
           })}
                style={{width: `${progress}%`}}/>
       </div>
    );
}
